//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'stage',
  title: 'Sierra Item',
  name: 'sierra-item',
  doubleKnitAssetTypeId: '67acdba2ee06eac3505f985f',
  knittingMachineCategoryId: '673c07b2a128eab872eb6c2d',
  dyeingMachineCategoryId: '67ad22cfee06eac3505f9866',
  stationsCategoryId: '67a652fc946531639e2c719e',
  proxyUrls: {
    assetApi: 'https://asset.api.stage.sierra-erp.com',
    itemApi: 'https://asset.api.stage.sierra-erp.com',
    userMasterApi: 'https://user.api.stage.sierra-erp.com',
  },
};
